<template>
  <div class="evergreen-info-popup">
    <!-- SLIDE 1: BIENVENIDA -->
    <div v-if="currentSlide === 1" class="slide">
      <template v-if="!newRegisteredUser">
        <div class="text-center center mt-base">
          <img src="https://cdn.redgirasol.com/investors/home/encino.svg" alt="" class="slide-icon">
          <h3 class="welcome-title mt-4 mb-3">Te damos la bienvenida<br><b>a la inversión Evergreen</b></h3>
        </div>
        <p class="mb-4">
          Hicimos varias mejoras a la plataforma pensando en ti, y de verdad nos alegra que seas parte de esto.<br><br>
          Aquí te explicamos cómo funciona y cómo puedes comenzar a invertir en RedGirasol.
        </p>
      </template>
      <template v-else>
        <div class="text-center center mt-base">
          <img src="https://cdn.redgirasol.com/investors/home/encino.svg" alt="" class="slide-icon">
          <h3 class="welcome-title mt-4 mb-3">Te damos la bienvenida<br><b>a RedGirasol</b></h3>
        </div>
        <p class="mb-4">
          Aquí no solo inviertes tu dinero: te unes a una comunidad que impulsa proyectos con impacto ambiental real.
          Nos alegra mucho que estés aquí.<br><br>
          Ponte cómod@, en un par de minutos te contamos cómo funciona todo.
        </p>
      </template>
    </div>

    <!-- SLIDE 2: COMO FUNCIONA -->
    <div v-else-if="currentSlide === 2" class="slide">
      <h3 class="bold mb-3 mt-base">Así funciona la Inversión Evergreen</h3>
      <p class="mb-3">Es una inversión <strong>sin plazo fijo</strong> que nunca deja de crecer.<br>
        Cuando inviertes en RedGirasol, tu dinero se diversifica en todos los créditos del portafolio de
        RedGirasol y genera <strong>pagos diarios</strong> que se reinvierten todos los días.
      </p>
      <p class="bold mb-2 mt-4">Cómo funciona:</p>
      <ul class="info-list mb-4">
        <li>Para comenzar, solo necesitas realizar un abono transfiriendo a tu CLABE personalizada hasta alcanzar por lo
          menos <b>$500 MXN.</b></li>
        <li>Tu dinero se <strong>diversificará en todos los créditos</strong> del portafolio de RedGirasol el
          día siguiente después de alcanzar el mínimo de $500 MXN. Ya no es necesario escoger los proyectos.</li>
        <li>Los pagos que recibes todos los días se <b>reinvierten</b> y generan aún más rendimiento.</li>
      </ul>
    </div>

    <!-- SLIDE 3: PRIMER ABONO -->
    <div v-else class="slide">
      <h3 class="bold mb-3 mt-base">¿Cómo realizar mi primer abono?</h3>
      <p class="mb-3">
        Para comenzar a invertir solo debes hacer una transferencia a tu CLABE personalizada. Aquí te decimos
        cómo:
      </p>
      <ul class="check-list mb-4 mt-5">
        <li>
          <span class="list-number mr-2">1</span>
          <span>En la app de tu banco, ve a la sección de <strong>Transferencia</strong>.</span>
        </li>
        <li>
          <span class="list-number mr-2">2</span>
          <span>Ingresa tu <b>CLABE personalizada {{ localStpClabe }}</b> <feather-icon icon="CopyIcon"
              svgClasses="w-5 h-5 text-dark cursor-pointer" @click.stop="copyToClipboard(localStpClabe)" />
            y seleccionas como banco <strong>STP</strong>.</span>
        </li>
        <li>
          <span class="list-number mr-2">3</span>
          <span>Realiza la transferencia ¡Y listo! Tu dinero ya formará parte de la inversión Evergreen.</span>
        </li>
      </ul>
      <p class="mb-3"><strong>Nota:</strong> Recuerda que el primer abono mínimo para entrar es de $500 MXN.</p>
      <p class="mb-3">
        ¿Tienes dudas? Nuestro
        <a :href="helpCenterUrl" target="_blank" rel="noopener" class="underline black bold">centro de ayuda</a> tiene
        toda la información sobre la inversión Evergreen.
      </p>
      <p>¡Sigamos creando un gran impacto juntos!</p>
    </div>

    <!-- CONTROLES: DOTS + BOTON -->
    <div class="carousel-footer text-center mt-5">
      <div class="dots mb-4">
        <span v-for="n in totalSlides" :key="n" class="dot" :class="{ active: currentSlide === n }"
          @click="currentSlide = n"></span>
      </div>
      <vs-button color="dark" type="filled" @click="next">{{ isLastSlide ? 'Entendido' : 'Siguiente' }}</vs-button>
      <div v-if="currentSlide == 2" class="mt-4">
        <a href="https://soporte.redgirasol.com/support/solutions/articles/48001285193--c%C3%B3mo-funciona-la-inversi%C3%B3n-evergreen-"
          target="_blank" rel="noopener" class="underline black bold">Saber más</a>
      </div>
    </div>
  </div>
</template>

<script>
import stpHelper from "@mixins/stpHelper";

export default {
  mixins: [stpHelper],
  name: "EvergreenInfoPopUp",
  props: {
    newRegisteredUser: { type: Boolean, default: false }
  },
  data() {
    return {
      currentSlide: 1,
      localStpClabe: null,
      totalSlides: 3,
      helpCenterUrl: 'https://soporte.redgirasol.com/support/solutions/articles/48001285193--c%C3%B3mo-funciona-la-inversi%C3%B3n-evergreen-'
    }
  },
  async mounted() {
    if (!this.localStpClabe) {
      this.localStpClabe = await this.getInvestorAccountStpClabe(this.InvestorId);
    }
  },
  computed: {
    isLastSlide() {
      return this.currentSlide === this.totalSlides;
    }
  },
  methods: {
    next() {
      if (!this.isLastSlide) {
        this.currentSlide++;
        return;
      }
      this.$emit('on-closed');
    },
    async copyToClipboard(value) {
      const el = document.createElement('textarea');
      el.value = value;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.successNotif('Copiado', "Información copiada al portapapeles");
    },
  }
}
</script>

<style lang="scss" scoped>
.evergreen-info-popup {
  padding: 0.5rem 1rem 1rem;

  .slide {
    padding: 1rem 2.5rem 1.5rem;
  }

  .slide-icon {
    width: 80px;
    height: 80px;
    margin: 0 auto;
  }

  .welcome-title {
    font-family: 'gilroyregular';

    b {
      font-family: 'gilroybold';
    }
  }

  .info-list,
  .check-list {
    padding-left: 0;
    list-style: none;
  }

  .info-list {
    padding-left: 1.25rem;
    list-style: disc;
  }

  .check-list li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0.75rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .carousel-footer {
    .dots {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }

    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #d8d8d8;
      cursor: pointer;
      transition: background-color 0.2s ease-in-out;

      &.active,
      &:hover {
        background: #28de18;
      }
    }

    .vs-button {
      min-width: 160px;
    }
  }

  .list-number {
    font-size: 12px;
    background-color: #28DE18;
    color: white;
    font-family: 'gilroybold';
    border-radius: 50%;
    height: 20px;
    width: 20px;
    min-width: 20px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-top: 2px;
  }
}
</style>
